export var CustomPDFReportModuleSize;
(function (CustomPDFReportModuleSize) {
    CustomPDFReportModuleSize["QUARTER_PAGE_BY_QUARTER_PAGE"] = "quarter_page_by_quarter_page";
    CustomPDFReportModuleSize["HALF_PAGE_BY_EIGHTH_PAGE"] = "half_page_by_eighth_page";
    CustomPDFReportModuleSize["FULL_PAGE_BY_EIGHTH_PAGE"] = "full_page_by_eighth_page";
    CustomPDFReportModuleSize["HALF_PAGE_BY_QUARTER_PAGE"] = "half_page_by_quarter_page";
    CustomPDFReportModuleSize["FULL_PAGE_BY_QUARTER_PAGE"] = "full_page_by_quarter_page";
    CustomPDFReportModuleSize["HALF_PAGE_BY_HALF_PAGE"] = "half_page_by_half_page";
    CustomPDFReportModuleSize["FULL_PAGE_BY_HALF_PAGE"] = "full_page_by_half_page";
    CustomPDFReportModuleSize["FULL_PAGE_BY_FULL_PAGE"] = "full_page_by_full_page";
})(CustomPDFReportModuleSize || (CustomPDFReportModuleSize = {}));
export var CustomPDFReportModuleCategory;
(function (CustomPDFReportModuleCategory) {
    CustomPDFReportModuleCategory["INTRODUCTION_AND_BASIC_INFO"] = "Introduction & Basic Info";
    CustomPDFReportModuleCategory["PERFORMANCE"] = "Performance";
    CustomPDFReportModuleCategory["RISK"] = "Risk";
    CustomPDFReportModuleCategory["ALLOCATIONS"] = "Allocations";
    CustomPDFReportModuleCategory["PROPOSALS_AND_SCENARIOS"] = "Proposals & Scenarios";
    CustomPDFReportModuleCategory["HOLDINGS"] = "Holdings";
    CustomPDFReportModuleCategory["ATTRIBUTION_ANALYSIS"] = "Attribution Analysis";
    CustomPDFReportModuleCategory["CHARTS_AND_TABLES"] = "Charts & Tables";
    CustomPDFReportModuleCategory["DISCLOSURES"] = "Disclosures";
})(CustomPDFReportModuleCategory || (CustomPDFReportModuleCategory = {}));
export var CustomPDFReportModuleFieldType;
(function (CustomPDFReportModuleFieldType) {
    CustomPDFReportModuleFieldType["BOOLEAN"] = "BooleanField";
    CustomPDFReportModuleFieldType["CHAR"] = "CharField";
    CustomPDFReportModuleFieldType["CUSTOM_TEXT"] = "CustomTextField";
    CustomPDFReportModuleFieldType["IMAGE"] = "ImageField";
    CustomPDFReportModuleFieldType["INFO_LIST"] = "InfoListField";
    CustomPDFReportModuleFieldType["SELECT"] = "SelectField";
    CustomPDFReportModuleFieldType["METRIC"] = "MetricField";
    CustomPDFReportModuleFieldType["METRICS_LIST"] = "MetricsListField";
    CustomPDFReportModuleFieldType["METRIC_GROUPS"] = "MetricGroupsField";
    CustomPDFReportModuleFieldType["MULTI_SELECT"] = "MultiSelectField";
    CustomPDFReportModuleFieldType["SAVED_ASSET_OPTIONS"] = "SavedAssetOptions";
    CustomPDFReportModuleFieldType["SAVED_ITEM_FIELD"] = "SavedItemField";
    CustomPDFReportModuleFieldType["SECURITY"] = "SecurityField";
    CustomPDFReportModuleFieldType["SECURITY_LIST"] = "SecurityListField";
    CustomPDFReportModuleFieldType["SELECT_TALKING_POINTS"] = "SelectTalkingPointsField";
    CustomPDFReportModuleFieldType["STRESS_TEST"] = "StressTestsField";
    CustomPDFReportModuleFieldType["TALKING_POINTS"] = "TalkingPointsField";
    CustomPDFReportModuleFieldType["RADIO_GROUP"] = "RadioGroupField";
    CustomPDFReportModuleFieldType["SELECT_TRANSITION_ANALYSIS"] = "SelectTransitionAnalysisField";
    CustomPDFReportModuleFieldType["SELECT_WITH_CUSTOM_VALUE"] = "SelectWithCustomValueField";
    CustomPDFReportModuleFieldType["RISK_PROFILES"] = "RiskProfilesListField";
    CustomPDFReportModuleFieldType["RISK_METRIC_FIELD"] = "RiskMetricField";
})(CustomPDFReportModuleFieldType || (CustomPDFReportModuleFieldType = {}));
